/* Tahoe Treats: menu, toast, AJAX cart drawer, combos, wholesale sample bags */
(function () {
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('tt-cart-config').textContent); } catch (e) { CFG = { threshold: 7500, combos: [], samples: [], fundraiser: [] }; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCartPage = document.body.classList.contains('tt-template-cart');
  var state = { cart: null };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function $all(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('tt-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }
  window.ttToast = toast;
  var mnav = document.getElementById('tt-mnav');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tt-burger]') && mnav) { mnav.setAttribute('aria-hidden', 'false'); }
    if (mnav && (e.target.closest('[data-tt-burger-close]') || e.target === mnav)) { mnav.setAttribute('aria-hidden', 'true'); }
  });
  var drawer = document.getElementById('tt-drawer');
  var lastFocus;
  function openDrawer() {
    if (onCartPage || !drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var p = drawer.querySelector('.tt-drawer__panel'); if (p) p.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tt-open-cart]');
    if (o && !onCartPage) { e.preventDefault(); refresh().then(openDrawer); return; }
    if (e.target.closest('[data-tt-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); if (mnav) mnav.setAttribute('aria-hidden', 'true'); }
  });
  function api(path, body) {
    var opts = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) {
      opts.method = 'POST';
      if (body instanceof FormData) { opts.body = body; }
      else { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    }
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw new Error(j.description || j.message || 'Something went wrong'); } return j; });
    });
  }
  function refresh() { return api('cart.js').then(function (c) { state.cart = c; render(); return c; }); }
  function add(items, label) {
    return api('cart/add.js', { items: items }).then(function () { return refresh(); })
      .then(function () { if (label) toast(label + ' added!'); openDrawer(); })
      .catch(function (err) { toast(err.message); refresh(); });
  }
  window.ttCartAdd = add;
  function change(key, qty) {
    return api('cart/change.js', { id: key, quantity: qty }).then(function (c) { state.cart = c; render(); })
      .catch(function (err) { toast(err.message); refresh(); });
  }
  function isFund(item) { return (CFG.fundraiser || []).indexOf(item.product_id) > -1 || !!(item.properties && (item.properties.Student || item.properties['Student name'])); }
  function splitTitle(t) { var i = t.indexOf(' - '); return i > -1 ? [t.slice(0, i), t.slice(i + 3)] : ['', t]; }
  function partMatch(part, item) {
    if (isFund(item)) return false;
    var m = part.match || '';
    if (m.charAt(0) === '=') return item.handle === m.slice(1);
    return item.handle.indexOf(m) === 0;
  }
  function lineHTML(item) {
    var t = splitTitle(item.product_title);
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    var pr = item.properties || {};
    var stu = pr.Student || pr['Student name'];
    var grp = pr.Group || pr.Team;
    var props = '';
    Object.keys(pr).forEach(function (k) {
      if (k.charAt(0) === '_' || !pr[k] || /^(Student|Student name|Group|Team)$/.test(k)) return;
      props += '<div class="tt-line__meta">' + esc(k) + ': ' + esc(pr[k]) + '</div>';
    });
    return '<div class="tt-line">' +
      '<a class="tt-line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="tt-line__main">' +
        (t[0] || isFund(item) ? '<div class="tt-line__kick">' + esc(isFund(item) ? 'Fundraiser' : t[0]) + '</div>' : '') +
        '<div class="tt-line__name">' + esc(t[1]) + '</div>' +
        '<div class="tt-line__meta">' + esc(variant) + (variant ? ' · ' : '') + money(item.final_price) + ' each</div>' + props +
        (stu ? '<span class="tt-line__stu">♥ Supporting ' + esc(stu) + (grp ? ' (' + esc(grp) + ')' : '') + '</span>' : '') +
      '</div>' +
      '<div class="tt-line__side">' +
        '<div class="tt-qty" role="group" aria-label="Quantity">' +
          '<button type="button" data-tt-q="' + esc(item.key) + '" data-n="' + (item.quantity - 1) + '" aria-label="One less">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-tt-q="' + esc(item.key) + '" data-n="' + (item.quantity + 1) + '" aria-label="One more">+</button>' +
        '</div>' +
        '<strong>' + money(item.final_line_price) + '</strong>' +
        '<button type="button" class="tt-x" data-tt-q="' + esc(item.key) + '" data-n="0">Remove</button>' +
      '</div></div>';
  }
  function shipHTML(cart) {
    if (CFG.wholesale) return '';
    var sub = 0, has = false;
    cart.items.forEach(function (i) { if (!isFund(i)) { sub += i.final_line_price; has = true; } });
    if (!has) return '';
    var th = CFG.threshold || 7500, left = th - sub, pct = Math.min(100, Math.round(sub / th * 100));
    return '<div class="tt-ship' + (left <= 0 ? ' is-done' : '') + '">' +
      (left <= 0 ? 'You unlocked free shipping!' : 'You’re ' + money(left) + ' away from free shipping') +
      '<div class="tt-ship__bar"><div class="tt-ship__fill" style="width:' + pct + '%"></div></div></div>';
  }
  function mixedHTML(cart) {
    var f = cart.items.filter(isFund), r = cart.items.filter(function (i) { return !isFund(i); });
    if (!f.length || !r.length) return '';
    var g = ''; f.some(function (i) { var p = i.properties || {}; g = p.Group || p.Team || ''; return !!g; });
    return '<div class="tt-notice"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" style="flex:none;margin-top:1px"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.5v.5"/></svg>' +
      '<div><b>Heads up: your order arrives in two parts.</b> Fundraiser items are delivered to ' + (g ? esc(g) : 'the student’s group') + ' when the fundraiser ends. Everything else ships to you now.</div></div>';
  }
  function comboHTML(cart) {
    if (CFG.wholesale) return '';
    var best = null, bestN = 0;
    (CFG.combos || []).forEach(function (c) {
      var n = c.parts.filter(function (p) { return cart.items.some(function (i) { return partMatch(p, i); }); }).length;
      if (n > bestN) { best = c; bestN = n; }
    });
    if (!best) return '';
    var missing = best.parts.filter(function (p) { return !cart.items.some(function (i) { return partMatch(p, i); }); });
    var items = best.parts.map(function (p) {
      var inC = missing.indexOf(p) < 0;
      return '<div class="tt-up__item' + (inC ? ' is-in' : '') + '"><img src="' + esc(p.img) + '" alt="">' + esc(p.label) + '<small>' + (inC ? '✓ In your cart' : money(p.price)) + '</small></div>';
    }).join('');
    if (!missing.length) {
      return '<div class="tt-up" style="background:var(--tt-mint);box-shadow:inset 0 0 0 2px #9BD84A"><span class="tt-up__kick">Combo unlocked</span><div class="tt-mk tt-up__title">' + esc(best.name) + '</div><div class="tt-small" style="color:#2F5A12">You’re saving ' + money(best.save) + '. It comes off at checkout.</div></div>';
    }
    var addable = missing.filter(function (p) { return p.variant && p.available; });
    var label = missing.length === 1 ? 'Add ' + missing[0].label : 'Add the other ' + missing.length;
    return '<div class="tt-up"><span class="tt-up__kick">Fan-favorite combo · save ' + money(best.save) + '</span>' +
      '<div class="tt-mk tt-up__title">' + esc(best.name) + '</div><div class="tt-up__row">' + items + '</div>' +
      (addable.length ? '<button type="button" class="tt-btn tt-btn--ink tt-btn--full tt-btn--sm" data-tt-combo="' + esc(JSON.stringify(addable.map(function (p) { return p.variant; }))) + '">' + esc(label) + ' · save ' + money(best.save) + '</button>' : '') +
      '</div>';
  }
  function samplesHTML(cart) {
    if (!CFG.wholesale || !(CFG.samples || []).length) return '';
    var codes = [];
    cart.items.forEach(function (i) { var m = /^RC-([A-Z]+)(3|6)$/.exec(i.sku || ''); if (m && codes.indexOf(m[1]) < 0) codes.push(m[1]); });
    if (!codes.length) return '';
    var list = CFG.samples.filter(function (s) { return s.variant; }).slice().sort(function (a, b) {
      return (codes.indexOf(a.code) < 0 ? 1 : 0) - (codes.indexOf(b.code) < 0 ? 1 : 0);
    });
    if (!list.length) return '';
    var rows = list.map(function (s) {
      var inCart = 0; cart.items.forEach(function (i) { if (i.variant_id === s.variant) inCart += i.quantity; });
      return '<div class="tt-up__ws"><div><b>1 lb ' + esc(s.label) + '</b><div class="tt-small">' + money(s.price) + ' each' + (inCart ? ' · ' + inCart + ' in cart' : '') + '</div></div>' +
        '<button type="button" class="tt-btn tt-btn--ink tt-btn--sm" data-tt-sample="' + s.variant + '" data-label="1 lb ' + esc(s.label) + '">Add</button></div>';
    }).join('');
    return '<div class="tt-up tt-up--ws"><span class="tt-up__kick">For your store</span><div class="tt-mk tt-up__title">Try a 1 lb bag for samples</div>' +
      '<div class="tt-small" style="margin:-4px 0 10px">Great for sampling Rainbow Crunch with your customers.</div>' + rows + '</div>';
  }
  function render() {
    var cart = state.cart; if (!cart) return;
    $all('[data-tt-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $all('[data-tt-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    $all('[data-tt-cart-foot]').forEach(function (el) { el.style.display = cart.item_count ? '' : 'none'; });
    var html;
    if (!cart.item_count) {
      html = '<div class="tt-empty"><div class="tt-mk">Your cart is empty</div><p class="tt-small">Let’s fix that.</p><a class="tt-btn tt-btn--ink" href="/collections/shop-all">Shop the crunch</a></div>';
    } else {
      html = shipHTML(cart) + cart.items.map(lineHTML).join('') + mixedHTML(cart) + samplesHTML(cart) + comboHTML(cart);
    }
    $all('[data-tt-cart-body]').forEach(function (el) { el.innerHTML = html; });
    document.dispatchEvent(new CustomEvent('tt:cart', { detail: cart }));
  }
  window.ttCartRefresh = refresh;
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-tt-q]');
    if (q) { e.preventDefault(); q.disabled = true; change(q.getAttribute('data-tt-q'), parseInt(q.getAttribute('data-n'), 10)); return; }
    var c = e.target.closest('[data-tt-combo]');
    if (c) { e.preventDefault(); c.disabled = true; add(JSON.parse(c.getAttribute('data-tt-combo')).map(function (id) { return { id: id, quantity: 1 }; }), 'Combo'); return; }
    var s = e.target.closest('[data-tt-sample]');
    if (s) { e.preventDefault(); s.disabled = true; add([{ id: parseInt(s.getAttribute('data-tt-sample'), 10), quantity: 1 }], s.getAttribute('data-label')); return; }
    var plus = e.target.closest('[data-tt-quick]');
    if (plus) {
      e.preventDefault(); e.stopPropagation();
      plus.setAttribute('aria-busy', 'true');
      add([{ id: parseInt(plus.getAttribute('data-tt-quick'), 10), quantity: 1 }], plus.getAttribute('data-label') || 'Treat').then(function () { plus.removeAttribute('aria-busy'); });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-tt-add]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    api('cart/add.js', new FormData(f)).then(function () { return refresh(); })
      .then(function () { toast((f.getAttribute('data-label') || 'Treat') + ' added!'); openDrawer(); })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  });
  refresh();
})();